module.exports = __webpack_public_path__ + "static/media/webscape_24_final.02c87f8f.jpg";